




























































































import {Vue, Component, Watch} from 'vue-property-decorator';
import LangTransition from '../../utils/lang/lang-transition.js';

@Component({
    components: {}
})
export default class GraphTransition extends Vue {
    lang:any = LangTransition;

    boxWidth = 1920;
    boxHeight = 1080;
    boxScale = 1;
    boxScale2 = 1;
    imgStyle = '';
    boxLeft = 0;
    boxTop = 0;
    showList = [1, 2];
    colorList = [
        {text: this.lang.likeKey, num: 3, color: '#03868d',},
        {text: this.lang.neutralKey, num: 8, color: '#03868d',},
        {text: this.lang.dislikeKey, num: 9, color: '#03868d',}
    ];

    animationScene1 = autoAnimation ? 'fly-in' : 'fly-out';
    animationScene2 = autoAnimation ? 'fly-out' : 'fly-in';

    animationPosition = autoAnimation ? 'fly-out': 'fly-in';
    animationHalo = autoAnimation ? 'fly-out' : 'fly-in';

    animationScene2Bg = 'fly-in';
    animationEarthInfo = 'fly-in';
    animationEarthLogo = 'fly-in';

    cancelToken: any;
    aef: any;

    makeStyle () {
        let styleObj = '';
        styleObj += `scale(${this.boxScale})`;
        // styleObj += '  translate(-50%)';
        this.imgStyle = styleObj;
        return styleObj;
    }

    created () {
        let targetWeight = 1920;
        let targetHeight = 1080;
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        let boxWidth = 0;
        let boxHeight = 0;
        if (windowWidth/windowHeight > targetWeight/targetHeight) {
            // 宽度更大
            boxHeight = windowHeight;
            boxWidth = targetWeight/targetHeight * boxHeight;
        } else {
            // 高度更大
            boxWidth = windowWidth;
            boxHeight = targetHeight/targetWeight * boxWidth;
        }
        this.boxWidth = boxWidth;
        this.boxHeight = boxHeight;
        // this.boxScale = 1;
        this.boxScale2 = boxWidth/targetWeight;
        this.boxLeft = (windowWidth - targetWeight) / 2;
        this.boxTop = (windowHeight - targetHeight) / 2;
        console.log(this.boxScale2, boxWidth, boxHeight);
        this.makeStyle();
        this.initAnimationConfig();
    }

    *actionScriptTransition () {
        // 两个地球的转场
        yield this.$sleep(2000); // 等2s
        this.animationScene1 = 'fly-out';
        this.animationScene2 = 'fly-in';
        yield Promise.all([
            this.$onNativeOnce('this.$refs.scene1'),
            this.$onNativeOnce('this.$refs.scene2')
        ]);

        // 场景2 左侧
        this.showList = [2];
        this.animationPosition = 'fly-in';
        yield this.$onNativeOnce('this.$refs.earthPosition');
        this.animationHalo = 'fly-in';
        yield this.$onNativeOnce('this.$refs.earthHalo');
        this.animationHalo = 'animation-in';
        yield this.$onNativeOnce('this.$refs.earthHalo', 'animationend', 1000 * 10);

        // 停一会 给用户看看信息
        yield this.$sleep(1000);

        // 场景2 地图飞走
        this.animationScene2Bg = 'fly-out';
        yield this.$sleep(0);
        yield this.$onNativeOnce('this.$refs.transitionScene2Bg');

        // 右侧信息和Logo飞走
        yield Promise.race([
            (async () => {
                this.animationEarthLogo = 'fly-out';
                await this.$onNativeOnce('this.$refs.earthLogo');
            })(),
            (async () => {
                this.animationEarthInfo = 'fly-out';
                await this.$onNativeOnce('this.$refs.earthInfo');
            })(),
        ]);
        this.animationEarthInfo = 'fly-out2';
        yield this.$onNativeOnce('this.$refs.earthInfo');

        if ($qsObj.jumpnext === 'false') {return void 0;}
        this.$bus.$emit('view-change', 'transition', '2d'); // 转跳到2d界面并开始2d动画
    }

    jumpTo2d () {
        this.cancelToken.abort();
        this.$bus.$emit('view-change', 'transition', '2d', true); // 转跳到2d界面并开始2d动画
    }

    initAnimationConfig () {
        if ($qsObj.view === 'transition') {
            if ($qsObj.scene === '2') {
                this.showList = [2];
            }
            if ($qsObj.auto === 'false') {
                this.animationScene1 = 'fly-out';
                this.animationScene1 = 'fly-in';
            }
        }
    }

    mounted () {
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptTransition, this.cancelToken);

        this.$autoOn('transition-start', this.aef);
        if ($qsObj.view === 'transition' && $qsObj.auto === 'true') {
            this.aef();
        }
    }
}
